<mat-card
  *ngIf="message$ | async as message"
  class="card" fxLayout="column" ngClass.xs="xs">
  <mat-card-header fxLayout="column" fxLayoutAlign="center center">
    <h1 class="header">
      {{ message.title ? message.title : 'Ups... Coś poszło nie tak.' }}
    </h1>
  </mat-card-header>
  <mat-card-content>
    <p *ngIf="message.msg" class="justify-text primary-color">
      {{ message.msg }}
    </p>
    <p *ngIf="(!!message.errorHash) && !message.msg" class="justify-text bold primary-color">
      Kod błędu: <code>{{ message.errorHash }}</code>
    </p>
  </mat-card-content>
  <mat-card-actions fxLayout="column" class="flex" style="align-self: center;">
    <selector [ngSwitch]="message.buttons">
      <div *ngSwitchCase="'CONTACT'" matDialogActions align="end">
        <button *ngIf="handsetService.isMobile" mat-raised-button color="accent" (click)="onCallClick()">Zadzwoń
        </button>
        <button mat-button matDialogClose (click)="onReportClick()">Napisz</button>
      </div>
      <div *ngSwitchCase="'YES_NO'" matDialogActions align="end">
        <button mat-raised-button matDialogClose color="accent" (click)="onYesClick()">TAK</button>
        <button mat-button matDialogClose (click)="onNoClick()">NIE</button>
      </div>
      <div *ngSwitchCase="'SAVE_CANCEL'" matDialogActions align="end">
        <button mat-raised-button matDialogClose color="accent" (click)="onSaveClick()">Zapisz</button>
        <button mat-button matDialogClose (click)="onCancelClick()">Anuluj</button>
      </div>
      <div *ngSwitchCase="'CLOSE'" matDialogActions align="end">
        <button mat-raised-button matDialogClose color="accent">Zamknij</button>
      </div>
      <div *ngSwitchCase="'CUSTOM'" matDialogActions align="end">
        <ng-container *ngFor="let button of message.customButtons ">
          <button *ngIf="button.isAccent" mat-raised-button matDialogClose color="accent"
                  (click)="button.onClick()">{{ button.label }}
          </button>
          <button *ngIf="!button.isAccent" mat-button matDialogClose (click)="button.onClick()">{{ button.label }}
          </button>
        </ng-container>
      </div>
    </selector>
  </mat-card-actions>
</mat-card>


